import {useGridRowGroup as $9364b4956b51a42c$export$d3037f5d3f3e51bf} from "../grid/useGridRowGroup.mjs";

/*
 * Copyright 2026 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ 
function $a88c5fd7483f9127$export$6fb1613bd7b28198() {
    return (0, $9364b4956b51a42c$export$d3037f5d3f3e51bf)();
}


export {$a88c5fd7483f9127$export$6fb1613bd7b28198 as useTableRowGroup};
//# sourceMappingURL=useTableRowGroup.mjs.map
